// extracted by mini-css-extract-plugin
module.exports = {"product-specs":"Specs_product-specs__gTsU8"};